const typeFactory = require("./types");

function questionCriteriaKeyMatch(criteriaJson, key) {
  if (!criteriaJson || !criteriaJson.length) return null;
  return criteriaJson.map(({ criteria }) => ({
    criteria: criteria[key] || null,
  }));
}

function eligibilityCriteriaStringList({ eligibilityCriteria, key, type }) {
  const eligibility = questionCriteriaKeyMatch(eligibilityCriteria, key);

  return eligibility ? typeFactory(type).serialize({ eligibility }) : null;
}

function paramString(something) {
  return typeof something === "string" ? JSON.parse(something) : something;
}

/**
 * Extract the eligibility criteria into a string
 *
 * @param {string|Object[]} eligibilityCriteria - Eligibility criteria rules. Evaluated with OR relation.
 * @param {string} keyTypeRelation.key - The question key to match the question and eligibility criteria
 * @param {string} keyTypeRelation.type - The question type e.g. 'yesno'
 * @returns {obj|null} - Provide the eligibility rules
 */
function extractor(eligibilityCriteria, keyTypeRelation) {
  const criteriaJson = paramString(eligibilityCriteria);
  return eligibilityCriteriaStringList({
    eligibilityCriteria: criteriaJson,
    key: keyTypeRelation.key,
    type: keyTypeRelation.type,
  });
}

module.exports = extractor;
